import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import {
  HOST_ORDER_VERIFIED,
  HOST_ORDER_COLLECTED,
  BUYER_ORDER_UNPAID,
  BUYER_REFUNDED,
  HOST_ORDER_SUBMITTED_VERIFIED,
  HOST_ORDER_SUBMITTED_COLLECTED,
  BUYER_ORDER_PAID
} from '_utils/constant'

const options = [
  { value: BUYER_ORDER_UNPAID, label: 'Not Paid' },
  { value: BUYER_REFUNDED, label: 'Refunded' },
  { value: HOST_ORDER_VERIFIED, label: 'Verified', type: 'host', includeSubmitted: HOST_ORDER_SUBMITTED_VERIFIED },
  { value: HOST_ORDER_COLLECTED, label: 'Collected', type: 'host', includeSubmitted: HOST_ORDER_SUBMITTED_COLLECTED },
  { value: BUYER_ORDER_PAID, label: 'Pending Review', isPending: true }
]

function SelectPaymentStatus({ onChangePaymentStatus, paymentStatus, isDisabled = false }) {
  const [state, setState] = useState({
    selectedOption: [],
  })

  useEffect(() => {
    setState({
      ...state,
      selectedOption: paymentStatus,
    })
  }, [paymentStatus])

  const handleChange = (selectedOption) => {
    setState({ selectedOption })
    onChangePaymentStatus({ selectedOption })
  }

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minWidth: '200px',
    }),
  }

  return (
    <>
      <Select
        isMulti
        closeMenuOnSelect={false}
        value={paymentStatus}
        onChange={handleChange}
        options={options}
        placeholder='Payment Status'
        className='rounded-0 ms-3 text-orange payment-status'
        isDisabled={isDisabled}
        styles={customStyles}
        getOptionValue={(option) => (option.isPending ? `${option.value}_pending` : `${option.value}`)}
      />
    </>
  )
}

export default SelectPaymentStatus
